<template>
  <div>
    <div
      v-if="isMoveToList"
      class="flex items-center"
    >
      <ResourceIcon
        class="mr-2"
        :src="moveFromResource?.icon"
        :color="moveFromResource?.color"
      />
      <span class="text-sm text-text-default">{{ moveFromResource?.title }}</span>
      <em
        class="custom-icons inline-flex w-4 h-4 mx-2"
        :style="getCustomIconStyle(iconPath('arrow-right'))"
      />
      <ResourceIcon
        class="mr-2"
        :src="moveToResource?.icon"
        :color="moveToResource?.color"
      />
      <span class="text-sm text-text-default">{{ moveToResource?.title }}</span>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed, onMounted, watch } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import ResourceIcon from '@/components/elements/common/ResourceIcon.vue';

const store = useStore();
const { iconPath, getCustomIconStyle } = useCustomIcon();

const props = defineProps({
  actionDetails: {
    type: Object,
    required: true,
  },
  cardId: {
    type: String,
    required: true,
  },
});

const isMoveToList = computed(() => {
  return !!props.actionDetails.status;
});

const existingCard = computed(() => {
  return store.getters.getCardById(props.cardId);
});

const boardId = computed(() => existingCard.value?.board_id);
const currentCardListId = computed(() => existingCard.value?.list_id);

const moveFromResource = computed(() => {
  if (isMoveToList.value && boardId.value) {
    if (currentCardListId.value) {
      return store.getters.lists[currentCardListId.value];
    }
  }
  return null;
});

const moveToResource = computed(() => {
  if (isMoveToList.value && boardId.value) {
    const boardsListsIds = store.getters.boardsListsIds[boardId.value];
    const existingListId = boardsListsIds?.find((listId) => {
      const list = store.getters.lists[listId];
      if (
        list.behavior === props.actionDetails.status ||
        list.title?.toLowerCase() === props.actionDetails.status
      )
        return listId;
      return null;
    });
    if (existingListId) {
      return store.getters.lists[existingListId];
    }
    return null;
  }
  return null;
});

const fetchBoard = async (id) => {
  const board = await store.dispatch('fetchBoard', { boardId: id });
  return board;
};

onMounted(() => {
  watch(
    boardId,
    (newBoardId) => {
      if (newBoardId) {
        fetchBoard(newBoardId);
      }
    },
    { immediate: true, once: true }
  );
});
</script>

<style lang="scss">
.suggested-action-details-item {
  @apply flex flex-col box-border gap-1;
}
</style>
